import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Message } from '../../../../../../components'
import { THEMES } from '../../../../../../utils/ui'
import { get } from 'lodash'

import './warning.component.scss'

/**
 * GDPR Warning Modal
 */
class GDPRWarningModal extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      isInitial: true,
      confirmation: {
        isCorrect: false,
        isForever: false
      }
    }

    this.renderContent = this.renderContent.bind(this)
  }

  /**
   * Get user confirmation of full GDPR status
   * @param data
   * @return {*}
   */
  renderContent (data) {
    const { isInitial, confirmation } = this.state
    const { isCorrect, isForever } = confirmation
    const institution = get(data, 'jobs[0].institution_name')

    return (
      <Fragment>
        <div className='message_card'>
          <div className='message_card-name'>{data.name || '-'}</div>
          <div className='message_card-institution'>{institution}</div>
        </div>
        <div className='message_confirm'>
          <div className='message_text'>Warning: This can't be undone</div>
          <Checkbox
            id='isCorrect'
            label='I acknowledge that this is the correct contact who has requested GDPR forgotten'
            theme={THEMES.WHITES}
            error={!isInitial && !isCorrect}
            isChecked={isCorrect}
            onChange={() => this.setState({ confirmation: { ...confirmation, isCorrect: !isCorrect } })} />
          <Checkbox
            id='isForever'
            label={`All content will be deleted forever and can't be reversed`}
            theme={THEMES.WHITES}
            error={!isInitial && !isForever}
            isChecked={isForever}
            onChange={() => this.setState({ confirmation: { ...confirmation, isForever: !isForever } })} />
        </div>
      </Fragment>
    )
  }

  /**
   * On submit validate all checkboxes
   */
  onSubmit = () => {
    const { onConfirm, onClose } = this.props
    const { confirmation } = this.state

    this.setState({ isInitial: false })

    if (confirmation.isCorrect && confirmation.isForever) {
      onClose && onClose()
      onConfirm && onConfirm()
    }
  }

  /**
   * Render
   * @return {*}
   */
  render () {
    const { data, onClose } = this.props
    const buttons = [
      {
        theme: 'shaded',
        label: 'Cancel',
        onClick: onClose
      },
      {
        theme: 'spice',
        label: 'Yes, Remove Content',
        onClick: this.onSubmit
      }
    ]

    return (
      <Message
        visible
        className='message-root--gdpr'
        type='warning'
        title='GDPR Warning!'
        message={'<p>You have flagged this contact for GDPR forgotten.</br>Please confirm below before proceeding.</p>'}
        children={this.renderContent(data)}
        useHtml
        buttons={buttons}
        onClose={onClose} />
    )
  }
}

GDPRWarningModal.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    jobs: PropTypes.array
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

GDPRWarningModal.defaultProps = {
  data: {}
}

export default GDPRWarningModal
